

export const getBookingsWidgetAccess = (allWidgets,widgetName)=>{

     if(allWidgets?.length > 0){
       return allWidgets?.find((item)=>item?.name?.toLowerCase() === widgetName?.toLowerCase());
     }
}